import { createApiClient } from "Network/ApiClient";
//api

export const PrescriberAxiosInstance = createApiClient("Prescriber/");
